module.exports = __webpack_public_path__ + "static/jenni-dc4ca99b91fb8c53b91683975f2f235a.jpg";